module.exports = __webpack_public_path__ + "media/og.f7a982b1.webm";